import { render, staticRenderFns } from "./adminregister.vue?vue&type=template&id=20bf5483&"
import script from "./adminregister.vue?vue&type=script&lang=js&"
export * from "./adminregister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports